var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedalThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.549805C4.99005 0.549805 2.5498 2.99005 2.5498 6C2.5498 9.00995 4.99005 11.4502 8 11.4502C11.01 11.4502 13.4502 9.00995 13.4502 6C13.4502 2.99005 11.01 0.549805 8 0.549805Z",
    stroke: "#414141",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5498C6.09462 2.5498 4.5498 4.09462 4.5498 6C4.5498 7.90538 6.09462 9.4502 8 9.4502C9.90538 9.4502 11.4502 7.90538 11.4502 6C11.4502 4.09462 9.90538 2.5498 8 2.5498Z",
    stroke: "#414141",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5L5 15.5L8 14L11 15.5V10.5",
    stroke: "#414141",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedalThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MedalThin.842305ab8bc2ac511ce71938e323e6d2.svg";